<template>
  <div class="login-content cg-page">
    <Header></Header>
		<div class="mt100" style="margin-top: 360px !important;">
      <div class="landing-page login">
        <div class="">
          <div class="input-div" style="margin-top:-100px;">
            <div class="span mt30 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('phoneNumber')}}</div>
            <div class="input-item">
              <div class="input-item2">
                <span>09</span>
                <input class="input" v-model="mobile" disabled placeholder="">
              </div>
            </div>
          </div>
          <div class="input-div">
            <div class="span fs33 crfff app-en fw7" style="font-weight: 400;margin-bottom: 15px;">OTP</div>
            <div class="input-item" style="background: none;">
              <div class="input-item2 disflex">
                <input class="input-item input" v-model="otp" ref="getFocus2" maxlength="4" type="number" style="width: 100%;height:80px;" placeholder="">
                <button class="btn btn-red" style="padding: 0 10px;min-height: 80px;line-height: 80px;min-width: 160px;margin-left:5px;font-size: 30px;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" style="font-size:50px;" @click="goLogin">{{$t('register')}}</button>
          </div>
          <div class="ac otp-b disflex crfff mt100">
            <div class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        type:'',
        password:'',
        otp:'',
        codeText:'',
        isReturn:false,
        isEN:'bur'

      }
    },
    watch: {
			otp(now,old) {
				let that = this;
				that.$nextTick(function() {
					if(now.length==4||old==now){
						that.timer = setTimeout(() => {
							that.$refs.getFocus2.blur();
						}, 100);
					}
				});
			},
		},
	created(){
    this.codeText = this.$t('getCode')
    this.mobile = this.$route.query.mobile
    this.type = this.$route.query.type
    if (this.$route.query.mobile){
      this.getSendOtp();
    }
	},
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      back(){
        this.$router.go(-1);
      },
      getSendOtp(){
        let that = this
        if(that.isReturn){
          return;
        }
        that.isReturn = true
        let data ={
            'mobile':this.$route.query.mobile
        }
        that.$api.post('/api/user/send_otp',data,r =>{
          that.$utils.alertText(r.msg,80,3000);
          this.countDown(61,1)
        })
      },
      goLogin(){
        let that = this
        if(that.mobile==''){
        	that.$utils.alertText(that.$t('loginTips'),80)
        	return;
        }
        let type = ''
        if(this.$route.query.type!=undefined){
          type = this.$route.query.type
        }
        var code  = this.$route.query.code
        let data ={
            'mobile':this.$route.query.mobile,
            'otp':this.otp,
            'code':code,
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/otp_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.isShowlogin = false
            that.mobile = ''
            that.otp = ''
            this.$router.push({path:'/'})
          }else{
            that.$utils.alertText(r.msg,80);
          }
        })
      },
      // 计时
      countDown (miao,type){
      	if(miao === 1){
      		this.codeText = this.$t('getCode');
      		return;
      	}
      	miao--;
      	if(type === 1){
      		this.codeText = miao + "s";
          this.isReturn = false
      	}
      	setTimeout(() =>{
      		this.countDown(miao,type);
      	},1000)
      }
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .otp-b{justify-content: space-evenly;}
  .login{margin-top:0px;}

  .btn-red{padding:20px 20px;background: #dd4765;width: auto;height: auto;display: block;margin: 0 auto;font-size:40px;}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue